// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function ButtonBase() {
  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false
      },
      styleOverrides: {
        root: {
          '&.MuiChip-root': {
            height: 24
          },
          '&.MuiIconButton-root': {
            height: 'unset',
            width: 'unset',
            padding: '6px'
          },
          '& .MuiSvgIcon-root': {
            width: '0.9em',
            height: '0.9em'
          }
        },
        focusVisible: {
          backgroundColor: 'unset'
        }
      }
    }
  };
}
